import { render, staticRenderFns } from "./jobfairUnits.vue?vue&type=template&id=4675de81&scoped=true"
import script from "./jobfairUnits.vue?vue&type=script&lang=js"
export * from "./jobfairUnits.vue?vue&type=script&lang=js"
import style0 from "./jobfairUnits.vue?vue&type=style&index=0&id=4675de81&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4675de81",
  null
  
)

export default component.exports